export function formatGlOptionLabel(codeOrLabel, name) {
  const code = String(codeOrLabel || '').trim();
  const rawName = name == null ? '' : String(name).trim();
  const combined = rawName ? `${code} - ${rawName}` : code;
  // Split only spaced label separators ("code - name"). Hyphens inside a code stay intact.
  const parts = combined.split(/\s+[-–—]\s+/).map((part) => part.trim()).filter(Boolean);
  if (!parts.length) return combined;
  const unique = [];
  parts.forEach((part) => {
    if (!unique.length || unique[unique.length - 1] !== part) unique.push(part);
  });
  return unique.join(' - ');
}
